module.exports = __webpack_public_path__ + "img/audio.07897b9b.png";